/* Variant-aware custom buy box. Powers price / compare / save / ATC label /
   availability / hidden variant-id (main + sticky) when a pdp-buy product has
   real options. Single-variant products render no picker, so this no-ops.
   Prices are pre-formatted server-side (Liquid `| money`) and swapped as text,
   so we never reimplement Shopify's money format. Deferred, no deps. */
(() => {
  'use strict';

  const initRoot = (root) => {
    if (root.dataset.buyVariantsInitialized === 'true') return;
    const dataEl = root.querySelector('[data-buy-variants]');
    if (!dataEl) return; // single-variant product — nothing to wire
    let variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;
    root.dataset.buyVariantsInitialized = 'true';

    const addLabel = root.getAttribute('data-add-label') || 'Add to cart';
    const soldOut = root.getAttribute('data-sold-out-label') || 'Sold out';

    const els = {
      compare: root.querySelector('[data-buy-compare]'),
      now: root.querySelector('[data-buy-now]'),
      save: root.querySelector('[data-buy-save]'),
      atc: root.querySelector('[data-buy-atc]'),
      atcLabel: root.querySelector('[data-buy-atc-label]'),
      // id inputs live in both the main form and the (out-of-root) sticky form
      ids: document.querySelectorAll('[data-buy-id]'),
      stickyPrice: document.querySelector('[data-sticky-price]'),
      stickyBtn: document.querySelector('[data-sticky-btn]'),
      stickyBtnLabel: document.querySelector('[data-sticky-atc-label]'),
    };

    const fieldsets = [...root.querySelectorAll('[data-buy-option]')];

    const selectedValues = () =>
      fieldsets.map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });

    const findVariant = () => {
      const sel = selectedValues();
      return variants.find(
        (v) => v.options.length === sel.length && v.options.every((o, i) => o === sel[i])
      );
    };

    const setHidden = (val) => {
      els.ids.forEach((i) => {
        i.value = val;
      });
    };

    const show = (el, on) => {
      if (!el) return;
      if (on) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    };

    const update = () => {
      const v = findVariant();
      // reflect active swatch styling regardless of match
      fieldsets.forEach((fs) => {
        fs.querySelectorAll('.pdp-buy__swatch').forEach((l) => {
          const input = l.querySelector('input');
          l.classList.toggle('is-active', !!(input && input.checked));
        });
      });
      if (!v) return;

      setHidden(v.id);
      if (els.now) els.now.textContent = v.price_formatted;
      if (els.compare) {
        els.compare.textContent = v.compare_formatted;
        show(els.compare, v.on_sale);
      }
      if (els.save) {
        els.save.textContent = 'Save ' + v.save_formatted;
        show(els.save, v.on_sale);
      }
      if (els.atcLabel) {
        els.atcLabel.textContent = v.available ? addLabel + ' — ' + v.price_formatted : soldOut;
      }
      if (els.atc) els.atc.disabled = !v.available;
      if (els.stickyPrice) els.stickyPrice.textContent = v.price_formatted;
      if (els.stickyBtn) els.stickyBtn.disabled = !v.available;
      if (els.stickyBtnLabel) els.stickyBtnLabel.textContent = v.available ? addLabel : soldOut;
    };

    fieldsets.forEach((fs) =>
      fs.querySelectorAll('input').forEach((i) => i.addEventListener('change', update))
    );

    // External hook so the fitment tool can pre-select an option (e.g. gauge
    // side) by dispatching: root.dispatchEvent(new CustomEvent('rinashi:select-option',
    // { detail: { name: 'Mounting Position', value: 'Left (Fuel Gauge)' } }))
    root.addEventListener('rinashi:select-option', (e) => {
      const detail = e.detail || {};
      const fs = fieldsets.find((f) => f.getAttribute('data-option-name') === detail.name);
      if (!fs) return;
      const input = [...fs.querySelectorAll('input')].find((i) => i.value === detail.value);
      if (input && !input.checked) {
        input.checked = true;
        update();
      }
    });

    update();
  };

  const boot = () => document.querySelectorAll('[data-buy-variants-root]').forEach(initRoot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
